import classes from './Overlay.module.css';
const Overlay = (props) => {
  return (
  <div className={`${classes.overlay} ${ 
          props.state === "entered"
          ? classes.entered
          : props.state === "entering"
          ? classes.entering
          : props.state === "exiting"
          ? classes.exiting
          : null}`} onClick={() => props.onClickHide()} >
  </div>
  )
}

export default Overlay;